import TokensService from '@omni/kit/services/TokensService';

import Environment from '../../../Environment';
import BaseService, { IHttpResponse, IUri, buildUrl } from '../../BaseService';
import { IGroupAttendances } from '../Types';

const RESOURCE = 'attendances';

interface IGetGroupAttendances extends Omit<IUri, 'resource'> {
  token?: string | null;
  filters: [string, string][];
}

interface IGetGroupAttendancesResponse extends IHttpResponse {
  body?: IGroupAttendances;
}

export default async ({
  token,
  filters,
}: IGetGroupAttendances): Promise<IGetGroupAttendancesResponse> => {
  const url = buildUrl({
    host: Environment.groupsHost,
    filters: filters,
    resource: RESOURCE,
  });
  const guestToken = await TokensService.getGuestToken();

  return BaseService.Get({
    url,
    token: token ? token : guestToken,
    skipTimestamp: true,
  });
};
